import { _throttle } from '@/utils/common';
import { getPrimaryColor } from '@/utils/theme';
// 为避免重复new 对象节省内存 这边记录上次new过的实例  如果实例存在 则返回旧的实例
let model;
let cfg;

let iconArray = [{ icon: '&#xe641;' }, { icon: '&#xec4f' }, { icon: '&#xec6d' }, { icon: '&#xe67e' }];

const equiIcon = {
    sensor: { icon: '&#xe674' },
    gateway: { icon: '&#xec5d' },
    display: { icon: '&#xe927' },
    relay: { icon: '&#xec5e' },
    gas: { icon: '&#xe99e' },
    magnetism: { icon: '&#xe638' },
    0: { icon: '&#xe674' },
    1: { icon: '&#xec5d' },
    2: { icon: '&#xe927' },
    3: { icon: '&#xec5e' }
};
var Point = function(x, y) {
    this.x = x;
    this.y = y;
};

var Model = function(id) {
    var me = this;
    this.id = id;
    this.canvas = document.getElementById(me.id);
    this.ctx = me.canvas.getContext('2d');
    this.imgX = null;
    this.imgY = null;
    this.imgScale = null;
    this.scale = 1;
    this.img = null;
    this.data = null;
    this.handle = null;
    this.pos = null;
    this.move = false;
    this.down = false;
    this.drop = false;
    this.path = '';
    this.mousedown = null;
    this.mousemove = null;
    this.mouseup = null;
    this.view = null;
    this.plan_view = [];
    this.nameParam = null;
    this.statusParam = null;
    this.carrierTypeParam = null;
    this.color = null;
    this.activeIdx = null;

    this.setPlanView = function(data) {
        me.plan_view = data;
    };

    this.setBackgroundImg = function(path) {
        me.path = path;
    };

    this.clear = function() {
        if (!!me.ctx && !!me.canvas) {
            me.ctx.clearRect(0, 0, me.canvas.width, me.canvas.height);
        }
        me.imgX = 0;
        me.imgY = 0;
        me.imgScale = 1;
        me.path = '';
    };

    this.draw = function(data, background) {
        me.setBackgroundImg(background);
        me.setData(data, true, true);
    };

    this.zoomIn = function(rate) {
        //放大
        me.imgScale = me.scale * (rate + 1);
        me.drawImg(this.nameParam, this.statusParam);
    };

    this.zoomOut = function(rate) {
        //缩小
        me.imgScale = me.scale / (rate + 1);
        me.drawImg(this.nameParam, this.statusParam);
    };
    this.setData = function(data, flag, isClone, param = {}) {
        //设置数据，如果flag == true,重新绘制canvas,isClone是否克隆data数据（默认否）
        /**
         * param可选值
         * nameParam 设备名称key
         * statusParam 设备状态key
         * carrierTypeParam 设备类型key
         * color ???
         */
        this.nameParam = param.nameParam || this.nameParam;
        this.statusParam = param.statusParam || this.nameParam;
        this.carrierTypeParam = param.carrierTypeParam || this.carrierTypeParam;
        this.color = param.color || this.color;
        this.activeIdx = param.active;

        me.data = [];
        if (isClone === true) {
            for (var i = 0; i < data.length; i++) {
                var obj = {};
                for (var key in data[i]) {
                    obj[key] = data[i][key];
                    obj.idx = i;
                }
                me.data.push(obj);
            }
        } else {
            me.data = data;
        }

        if (flag === true) {
            me.loadImg(param.nameParam, param.statusParam);
        }
    };

    this.getData = function() {
        return me.data;
    };

    this.refresh = function(flag) {
        //刷新，如果flag == true，刷新所有信息（包括坐标等）
        if (flag == true) {
            me.imgX = 0;
            me.imgY = 0;
            me.imgScale = 1;
        }
        me.loadImg();
    };

    this.loadImg = function(nameParam, statusParam) {
        me.imgX = me.imgX == null ? 0 : me.imgX;
        me.imgY = me.imgY == null ? 0 : me.imgY;
        me.imgScale = me.imgScale == null ? 1 : me.imgScale;
        if (!!me.path) {
            me.img = me.img == null ? new Image() : me.img;
            me.img.onload = function() {
                me.drawImg(nameParam, statusParam);
            };
            me.img.src = me.path;
        } else {
            me.drawImg(nameParam, statusParam);
        }
    };

    this.drawImg = function(nameParam = 'carrierName', statusParam = 'abnormal') {
        me.ctx.clearRect(0, 0, me.canvas.width, me.canvas.height);
        if (!!me.img) {
            me.ctx.drawImage(me.img, 0, 0, me.img.width || '', me.img.height, me.imgX, me.imgY, me.img.width * me.imgScale, me.img.height * me.imgScale);
        }

        if (me.data.length != 0) {
            // console.log(me.data);
            label: for (var i = 0; i < me.data.length; i++) {
                var obj = me.data[i];
                console.log('obj===', obj)

                if (me.handle != null) {
                    me.handle(obj, me);
                    continue label;
                }

                if (!!obj.icon) {
                    var icon = new Image();
                    icon.onload = function() {
                        me.drawIcon(icon, obj.xpos, obj.ypos);
                    };
                    icon.src = obj.icon;
                } else {
                    me.ctx.beginPath();
                    // me.drawDeviceIcon(obj.xpos, obj.ypos, obj.typeStatus); //描点(默认圆点)
                    // me.drawIcon(obj.img,obj.xpos, obj.ypos)

                    // me.drawIconfont(obj[statusParam], obj.xpos, obj.ypos, i, obj[this.carrierTypeParam]);

                    //me.ctx.font = '14px iconfont';
                    // // me.imgX + px * me.imgScale, me.imgY + py * me.imgScale, 8 * me.imgScale,
                    // me.ctx.fillText(eval(('("' + iconArray[i].icon).replace('&#x', '\\u').replace(';', '') + '")'), obj.xpos, obj.ypos)

                    //新需求，判断是设备还是监测点，设备描点圆点，监测点描正方形
                    // 有carrier_id属性的判断为监测点
                    if(obj.carrierId){
                        me.drawCarrierRect(obj.xpos, obj.ypos)
                    }

                    me.ctx.fill();
                    me.ctx.lineWidth = 1;
                    me.ctx.stroke();
                    me.ctx.closePath();
                }
                me.ctx.beginPath();
                // 先把原来的颜色保存下来
                const copyColor = this.color;

                // 监测点文案
                if (this.activeIdx !== undefined && obj.idx !== this.activeIdx) {
                    this.color = undefined;
                    // 不需要在旁边标出名称了
                    me.drawText('', '', obj.xpos, obj.ypos - 10, 0);
                } else {
                    this.color = copyColor;
                    me.drawText('', '', obj.xpos, obj.ypos - 10, 0);
                }
                this.color = copyColor;

                // me.plan_view.forEach(function(v, i) {
                //     var val = '';
                //     var unit = '';
                //     if (typeof v.unit != 'undefined' && v.unit != null) {
                //         unit = obj[v.unit];
                //     }
                //     if (typeof obj[v.key] != 'undefined' && obj[v.key] != null) {
                //         val = obj[v.key];
                //         me.drawText(val, unit, obj.xpos, obj.ypos, ++i, '');
                //     }
                // });

                me.ctx.closePath();
            }
        }
    };

    this.drawIcon = function(img, xpos, ypos) {
        me.ctx.drawImage(img, xpos + me.imgX, ypos + me.imgY, img.width * me.imgScale, img.height * me.imgScale);
    };
    // brian添加绘制iconfont图标作为锚点  date:2022 05 27
    this.drawIconfont = function(status, xpos, ypos, i, type = 1) {
        if (status == 0 || status === false) {
            // 主题色  0否
            me.ctx.fillStyle = '#344962';
        } else {
            // 红色  1是
            me.ctx.fillStyle = '#af0202';
        }
        me.ctx.font = '24px iconfont';
        // 类型是数字的话 走的是监测点   否则走的是设备
        if (typeof type === 'number')
            me.ctx.fillText(eval(('("' + iconArray[type - 1].icon).replace('&#x', '\\u').replace(';', '') + '")'), me.imgX + xpos * me.imgScale, me.imgY + ypos * me.imgScale);
        else {
            me.ctx.fillText(eval(('("' + equiIcon[type].icon).replace('&#x', '\\u').replace(';', '') + '")'), me.imgX + xpos * me.imgScale, me.imgY + ypos * me.imgScale);
        }
    };
    this.drawText = function(val, unit, xpos, ypos, index, type) {
        //设置字体样式
        me.ctx.font = 'bold 14px sans-serif';
        if (!!type) {
            me.ctx.fillStyle = this.color ? `${this.color}` : 'red';
        } else {
            //设置字体填充颜色
            me.ctx.fillStyle = this.color ? `${this.color}` : getPrimaryColor();
        }
        //从坐标点开始绘制文字
        me.ctx.fillText(val + unit, 30 + me.imgX + xpos * me.imgScale, me.imgY + ypos * me.imgScale + 5 + index * 14 * me.imgScale);
    };

    this.drawDeviceIcon = function(px, py, type) {
        switch (type) {
            case 0: //正方形
                me.ctx.rect(me.imgX + px * me.imgScale, me.imgY + py * me.imgScale, 15, 15);
                return;
            case 1: //圆点
                me.ctx.arc(me.imgX + px * me.imgScale, me.imgY + py * me.imgScale, 8, 0, Math.PI * 2, true);
                return;
            case 2: //菱形
                me.createPolygonPath(me.imgX + px * me.imgScale, me.imgY + py * me.imgScale, 10, 4, 0);
                return;
        }
        me.ctx.arc(me.imgX + px * me.imgScale, me.imgY + py * me.imgScale, 8 * me.imgScale, 0, Math.PI * 2, true);
    };

    // 新需求，监测点描点时显示正方形就行
    this.drawCarrierRect = function(px, py) {
        me.ctx.fillStyle = "green";
        me.ctx.strokeStyle = "green";
        me.ctx.rect(me.imgX + px * me.imgScale, me.imgY + py * me.imgScale, 15, 15);
    };
    this.getPolygonPoints = function(centerX, centerY, radius, sides, startAngle) {
        var points = [],
            angle = startAngle || 0;
        for (var i = 0; i < sides; ++i) {
            points.push(new Point(centerX + radius * Math.sin(angle), centerY - radius * Math.cos(angle)));
            angle += (2 * Math.PI) / sides;
        }
        return points;
    };

    this.createPolygonPath = function(centerX, centerY, radius, sides, startAngle) {
        var me = this;
        var points = this.getPolygonPoints(centerX, centerY, radius, sides, startAngle);
        me.ctx.beginPath();
        me.ctx.moveTo(points[0].x, points[0].y);
        for (var i = 1; i < sides; ++i) {
            me.ctx.lineTo(points[i].x, points[i].y);
        }
        me.ctx.closePath();
    };

    this.windowToCanvas = function(canvas, x, y) {
        var box = canvas.getBoundingClientRect();
        return {
            x: x - box.left - (box.width - canvas.width) / 2,
            y: y - box.top - (box.height - canvas.height) / 2
        };
    };

    this.moveCanvas = function(event) {
        me.drop = true;
        me.canvas.style.cursor = 'move';
        var currentPos = me.windowToCanvas(me.canvas, event.pageX, event.pageY);
        var x = currentPos.x - me.pos.x;
        var y = currentPos.y - me.pos.y;
        me.pos = currentPos;
        me.imgX += x;
        me.imgY += y;
        me.drawImg(this.nameParam, this.statusParam, this.color);
    };

    this.eventInit = function() {
        me.canvas.onmousedown = function(e) {
            if (me.img == null) return;
            me.down = true;
            me.pos = me.windowToCanvas(me.canvas, event.pageX, event.pageY);
            if (me.mousedown != null) {
                me.mousedown(me.down, me.drop, me.data, me.pos, e);
            }
        };

        // 节流处理
        const mousemove = _throttle(function(event) {
            if (me.mousemove != null) {
                var pos = me.windowToCanvas(me.canvas, event.pageX, event.pageY);
                me.mousemove(me.down, me.drop, me.data, pos);
            }

            if (!me.down) return;
            if (me.move) {
                //canvas移动事件
                me.moveCanvas(event);
            }
        }, 50);

        me.canvas.addEventListener('mousemove', function(event) {
            mousemove(event);
        });

        me.canvas.addEventListener('mouseup', function(e) {
            //从canvas释放鼠标

            me.canvas.onmousemove = null;
            me.canvas.onmouseup = null;
            me.canvas.style.cursor = 'default';
            me.pos = me.windowToCanvas(me.canvas, e.pageX, e.pageY);
            var posX = (me.pos.x - me.imgX) / me.imgScale;
            var posY = (me.pos.y - me.imgY) / me.imgScale;

            // 利用两点间距离公式求出点击的taget
            const target =
                me.data[
                    me.data.findIndex(item => {
                        return Math.sqrt(Math.pow(item.xpos - posX + 7, 2) + Math.pow(item.ypos - posY - 7, 2)) * me.imgScale < 14;
                    })
                ];

            if (me.mouseup != null) {
                me.mouseup(me.img, me.down, me.drop, me.data, posX, posY, me.pos, e, target);
            }
            me.drop = false; //释放鼠标标记
            me.down = false; //释放鼠标行动标记
        });
    };
};

// 按理说不应该这么写 在全局不可能只有一个实例
function getInstance(config) {
    let model = new Model(config.id);
    if (typeof config.handle == 'function') {
        model.handle = handle;
    }
    model.move = config.move == true ? true : false;
    model.mouseup = typeof config.mouseup == 'function' ? model.mousedown || config.mouseup : null;
    model.mousedown = typeof config.mousedown == 'function' ? model.mousedown || config.mousedown : null;
    model.mousemove = typeof config.mousemove == 'function' ? model.mousedown || config.mousemove : null;
    model.eventInit();
    return model;
}
export { getInstance, Model };
